import { DropdownMenuItem } from './dropdown-menu'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuTrigger,
} from './dropdown-menu'
import { Fragment } from 'react/jsx-runtime'

function UI_DropdownMenu({
  children,
  items,
  ...props
}: {
  children: React.ReactNode
  items: {
    label: string | React.ReactNode
    icon?: React.ReactNode
    onClick: React.MouseEventHandler<HTMLDivElement>
  }[]

  onOpenChange?: (open: boolean) => void
  open?: boolean
}) {
  return (
    <DropdownMenu modal {...props}>
      <DropdownMenuTrigger asChild>{children}</DropdownMenuTrigger>
      <DropdownMenuContent align='start'>
        <DropdownMenuGroup className='*:data-[slot=dropdown-menu-item]:[&>svg]:text-muted-foreground'>
          {items.map((item, index) => (
            <Fragment key={'dropdown-menu-item' + index + item.label}>
              <DropdownMenuItem key={index} onClick={item.onClick}>
                {item.icon}
                {item.label}
              </DropdownMenuItem>
              {/* {index !== items.length - 1 && <DropdownMenuSeparator />} */}
            </Fragment>
          ))}
        </DropdownMenuGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

export { UI_DropdownMenu }
